<template>
  <div id='ball' class='ball' @click='goHome'>
    <img src='../../assets/images/icon-home.png'>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Ball',
  props: {
    platformPower: {
      type: String,
      default () {
        return 'userClient'
      }
    }
  },
  data () {
    return {
      showImg: false
    }
  },
  computed: {
    ...mapGetters([
      'initHosp'
    ])
  },
  created () {
    this.isMini = this.$store.getters.platform === 'mp' ? true : false
  },
  mounted () {
    new Inertia(document.getElementById('ball'), { edge: true })
  },
  methods: {
    goHome () {
      if (this.isMini) {
        if (this.platformPower === 'userClient') {
          wx.miniProgram.switchTab({
            url: '/pages/userIndex/main'
          })
        } else {
          wx.miniProgram.redirectTo({
            url: '/pages/doctorInquiry/main'
          })
        }
      } else {
        // 初始化为单院时
        if (this.initHosp.mode === '1') {
          this.$router.push({ path: '/counselor' })
        }
        if (this.initHosp.mode === '2') {
          this.$router.push({ path: '/hospitalList' })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Ball.vue